import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import styles from "../ActivityTypesCommon.module.scss";

import ActivityTypeItem from "./ActivityTypeItem";

interface Props {
  inactiveTypes: ActivityType[];
  onActivate: (id: ActivityType["id"], active: boolean) => void;
  onRename: (activityType: ActivityType, newName: string) => void;
}

const InactiveList: React.FC<Props> = ({ inactiveTypes, onActivate, onRename }) => {
  const intl = useIntl();

  return inactiveTypes.length > 0 ? (
    <>
      <p className={cn(styles.activityTypeListTitle, styles.activityTypeListTitleDisabled)}>
        {intl.formatMessage({
          id: "settings.activityTypes.disabledList.title",
          defaultMessage: "Disabled Types",
          description: "Label for Disabled type list on settings",
        })}
      </p>
      {inactiveTypes.map((item, index) => (
        <ActivityTypeItem
          activityType={item}
          className={styles.activityType}
          index={index}
          isDisabled
          key={`disabled-activity-type-${item.id}`}
          onActivate={onActivate}
          onRename={onRename}
        />
      ))}
    </>
  ) : null;
};

export default InactiveList;
